import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { CreditCard, Smartphone, Building2, Wallet, Star } from 'lucide-react';
import { PAYMENT_METHODS } from '../types/index';

const METHOD_TABS = [
    { id: PAYMENT_METHODS.CARD, label: 'Card', icon: CreditCard },
    { id: PAYMENT_METHODS.UPI, label: 'UPI', icon: Smartphone },
    { id: PAYMENT_METHODS.NET_BANKING, label: 'Net Banking', icon: Building2 },
    { id: PAYMENT_METHODS.WALLET, label: 'Wallet', icon: Wallet },
    { id: PAYMENT_METHODS.SAVED, label: 'Saved', icon: Star },
];

/**
 * Renders tab navigation for selecting a payment method.
 * Renders each method form via render prop children(method).
 *
 * @param {{
 *   selectedMethod: string,
 *   onMethodChange: (method: string) => void,
 *   children: (method: string) => React.ReactNode,
 * }} props
 */
export function PaymentMethodSelector({ selectedMethod, onMethodChange, children }) {
    return (
        <Tabs
            value={selectedMethod}
            onValueChange={onMethodChange}
            className="w-full"
            data-testid="payment-method-selector"
        >
            <TabsList
                className="grid w-full bg-slate-100 rounded-sm p-1 mb-6"
                style={{ gridTemplateColumns: `repeat(${METHOD_TABS.length}, 1fr)` }}
                aria-label="Payment method"
            >
                {METHOD_TABS.map(({ id, label, icon: Icon }) => (
                    <TabsTrigger
                        key={id}
                        value={id}
                        data-testid={`tab-${id.toLowerCase()}`}
                        className="flex flex-col sm:flex-row items-center gap-1 text-xs sm:text-sm font-medium
              rounded-sm transition-all duration-200
              data-[state=active]:bg-white data-[state=active]:text-[#F87217]
              data-[state=active]:shadow-sm"
                    >
                        <Icon className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
                        <span className="hidden sm:inline">{label}</span>
                    </TabsTrigger>
                ))}
            </TabsList>

            {METHOD_TABS.map(({ id }) => (
                <TabsContent key={id} value={id} className="mt-0 focus-visible:outline-none">
                    {children(id)}
                </TabsContent>
            ))}
        </Tabs>
    );
}
